import { render, staticRenderFns } from "./ERegistrationProfessionalActivateView.vue?vue&type=template&id=0478a99b&scoped=true&"
import script from "./ERegistrationProfessionalActivateView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationProfessionalActivateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0478a99b",
  null
  
)

export default component.exports